var map = {
	"./about-app/game.svg": 586,
	"./about-app/learn.svg": 587,
	"./about-app/scan.svg": 588,
	"./about-app/tips.svg": 589,
	"./arrow.svg": 548,
	"./bt-round-active.svg": 556,
	"./bt-round-hover.svg": 557,
	"./bt-round.svg": 558,
	"./check-box-checked.svg": 547,
	"./close.svg": 639,
	"./contract.svg": 640,
	"./done.svg": 559,
	"./download.svg": 641,
	"./east-arrow.svg": 549,
	"./email.svg": 642,
	"./feedback.svg": 302,
	"./game.svg": 643,
	"./go.svg": 644,
	"./menu.svg": 645,
	"./next.svg": 646,
	"./polygon_arrow.svg": 552,
	"./search.svg": 647,
	"./sign.svg": 303,
	"./vertical_dots.svg": 546,
	"./words-containing-outlined.svg": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 638;